import React from 'react';
import MessengerCustomerChat from 'react-messenger-customer-chat';
const Blog = () => {
    return (
        <div className="text-center">
            <h1>coming soon........</h1>
            <MessengerCustomerChat
        pageId="<PAGE_ID>"
        appId="<APP_ID>"
      />
        </div>
    );
};

export default Blog;